import { render, staticRenderFns } from "./u-header-fixed.vue?vue&type=template&id=e2345d94&scoped=true&"
import script from "./u-header-fixed.vue?vue&type=script&lang=js&"
export * from "./u-header-fixed.vue?vue&type=script&lang=js&"
import style0 from "./u-header-fixed.vue?vue&type=style&index=0&id=e2345d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2345d94",
  null
  
)

export default component.exports